import React from 'react';
import { siteConfig } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 bg-gray-50 border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Tagline */}
          <p className="text-gray-400 font-light text-sm tracking-wide">
            {siteConfig.name} — {siteConfig.tagline}
          </p>

          {/* Copyright */}
          <p className="text-gray-300 text-sm font-light">
            © {currentYear} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
